import React, { useState, useEffect } from 'react';

// Material UI
import MenuItem  from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

// Components
import BranchesModal from '../branchesModal';

// Hooks
import useUser from '../../../hooks/user/useUser';

const SelectCashRegisterMenu = () => {
    const { cashRegister } = useUser();
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <>
            <MenuItem 
                onClick={handleClick}
            >
                <ListItemText 
                    primary='Caja' 
                    secondary={cashRegister?.name}
                />
            </MenuItem>
            {
                open &&
                <BranchesModal 
                    change
                    onClose={() => setOpen(false)}
                />
            }
        </>
    )
}

export default SelectCashRegisterMenu;